import React from 'react';

import { formatPrice } from '../../utils/string';
import { BasicInfoBox } from './VehicleCard';
import {
  InfoBoxIcon,
  InfoBoxMoneyValue,
  InfoBoxTitle,
  InfoBoxValue,
  InfoBoxValueContainer,
  InfoBoxValuesContainer,
  VehicleInfoBoxContainer,
} from './VehicleCard.styles';

export interface MoneyBox extends BasicInfoBox {
  currency: 'USD' | 'CAD';
  amount: number;
  value1?: string;
  icon1?: JSX.Element;
}

const VehicleMoneyBox = ({ data }: { data: MoneyBox }) => {
  return (
    <VehicleInfoBoxContainer>
      {data.title && <InfoBoxTitle>{data.title}</InfoBoxTitle>}
      <InfoBoxValuesContainer $noGap>
        <InfoBoxValueContainer>
          <InfoBoxMoneyValue>{formatPrice(data.amount, data.currency)}</InfoBoxMoneyValue>
        </InfoBoxValueContainer>
        <InfoBoxValueContainer>
          {data.icon1 && <InfoBoxIcon>{data.icon1}</InfoBoxIcon>}
          {data.value1 && <InfoBoxValue>{data.value1}</InfoBoxValue>}
        </InfoBoxValueContainer>
      </InfoBoxValuesContainer>
    </VehicleInfoBoxContainer>
  );
};

export default VehicleMoneyBox;
